import React, {useEffect, useMemo} from 'react'
import styled from '@emotion/styled'
import {TranslatedLOVItem} from '@findhotel/sapi'
import {GroupedFacilities} from 'types/Hotel'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
import {useDispatchTeamEvent} from '@vio/core/src/analytics/hooks/useDispatchTeamEvent'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {AP_DESKTOP_LARGE_COLUMN_WIDTH} from '../AccommodationView/Desktop/constant'
import {FacilitiesGrid} from '../Facilities/FacilitiesGrid'
import {FacilitiesGroupItem} from '../Facilities/FacilitiesGroupItem'
import {getDistributeColumns} from './utils'

const GroupedFacilitiesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${cssTheme.layout.spacing.s900};
  max-width: ${AP_DESKTOP_LARGE_COLUMN_WIDTH}px;
`
const FacilitiesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${cssTheme.layout.spacing.s800};
`
interface Props {
  groupedFacilities: GroupedFacilities[]
  topFacilities: TranslatedLOVItem[]
}
export const FacilitiesSection: React.FC<Props> = ({
  groupedFacilities,
  topFacilities
}) => {
  const {inView} = useInView({triggerOnce: true, threshold: 0.5})
  const dispatchTeamEvent = useDispatchTeamEvent()

  const distributeColumns = useMemo(() => {
    return getDistributeColumns(groupedFacilities)
  }, [groupedFacilities])
  useEffect(() => {
    if (inView) {
      dispatchTeamEvent(
        trackEvent({
          category: Category.User,
          entity: Entity.HotelDetailsFacilitiesSection,
          action: Action.Viewed
        })
      )
    }
  }, [dispatchTeamEvent, inView])
  return (
    <Box display="flex" flexDirection="column" gap="s600">
      <Box display="flex" flexDirection="column" gap="s500">
        <Text variant="titleXL" tag="p">
          <FormattedMessageWrapper
            id="popularAmenities"
            defaultMessage="Popular amenities"
          />
        </Text>
        <FacilitiesGrid facilities={topFacilities} />
      </Box>

      <Divider />

      <GroupedFacilitiesWrapper>
        <FacilitiesWrapper>
          {distributeColumns.firstColumn?.map(item => (
            <FacilitiesGroupItem
              key={item.categoryId}
              categoryId={item.categoryId}
              facilities={item.facilities}
            />
          ))}
        </FacilitiesWrapper>
        <FacilitiesWrapper>
          {distributeColumns.secondColumn?.map(item => (
            <FacilitiesGroupItem
              key={item.categoryId}
              categoryId={item.categoryId}
              facilities={item.facilities}
            />
          ))}
        </FacilitiesWrapper>
      </GroupedFacilitiesWrapper>
    </Box>
  )
}
